import { takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/core';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { LoginService } from '../../api/login-service';
import Translator from '../../core/i18n';

const T = Translator.create();
const _logger = Log.create('Request Sagas');

function* requestRefreshToken(params: any): any {

    const _loginService = new LoginService();
    const _common = new Common();

    const requestReturn = yield _loginService.RequestAccessTokenByRefreshTokenAsync(params.refreshToken)
        .then((returnData: Response) => {
            return returnData.json();
        }).then((returnData: any) => {
            
            if (returnData.access_token !== undefined) {
                const inDate = new Date();
                inDate.setSeconds(inDate.getSeconds() + returnData.expires_in);       
                const AuthInf = {
                    access_token: returnData.access_token,
                    refresh_token: returnData.refresh_token,
                    expire_date: inDate,
                    auth_url: window.appSettings.AUTH_URL
                };
                _common.InsertAuthLocalStorage(AuthInf);
                _common.InsertRefreshingLocalStorage(false);
            }
        });
}

export function* watchRequestRefreshToken() {
    yield takeEvery(constants.actions.CORE_REQUEST, requestRefreshToken);
}


export default function* requestSagas() {
    yield all([
        watchRequestRefreshToken()
    ]);
}
